export const presentationSummary = `
이 챗봇은 "Generative AI Applications for Individuals"라는 주제로 한 발표 내용을 바탕으로 질문에 답변합니다.

📌 주요 개념:
- AI는 기존 컴퓨터와 달리 '학습'과 '결론 도출'이 가능해 스스로 판단합니다.
- Generative AI(생성형 AI)는 LLM(대규모 언어 모델)을 통해 문맥을 이해하고 새로운 텍스트, 이미지, 영상 등을 생성합니다.

📌 핵심 기술:
1. Prompt Engineering: 원하는 결과를 얻기 위해 AI에게 구체적이고 명확한 질문을 설계하는 기술입니다.
   - 예: "커피에 대해 알려줘"보다 "커피의 유래와 종류를 3줄 요약해줘"가 더 좋은 프롬프트입니다.
2. RAG (Retrieval-Augmented Generation): AI가 학습하지 않은 최신 정보나 외부 지식을 검색하여 답변에 활용하도록 하는 기술입니다.

📌 개인을 위한 생성형 AI 활용 예시:
- 학업: 논문 요약(DeepL), 회의록 기록(Clova Note)
- 콘텐츠 제작: 영상 생성(Sora), 로고 디자인(Firefly)
- 일정 관리: ChatGPT와 하루 계획, 활동 리뷰
- 리서치: Perplexity, Lilys.ai
- AI 챗봇: Character.AI, 뤼튼
- 실습 프로젝트: '페르소나 채지희'는 사용자의 질문에 자연스럽게 답변하는 맞춤형 AI 캐릭터로, 성격·말투 등을 커스터마이징하여 몰입감 높은 대화 경험을 제공합니다.

📌 국내외 기업 동향:
- 국내: SK, 네이버, 카카오, 삼성 등은 기업용 AI와 자체 모델 개발에 집중
- 해외: Microsoft(GPT 기반), Google(Gemini), Meta(LLaMA2) 등은 개인용 AI 서비스에 적극적

📌 경제적 영향:
- 노동 생산성 향상: AI가 업무 자동화 및 개인화 지원
- AI 시장 성장 전망: 2027년까지 1210억 달러 규모 예상 (BCG)

이 챗봇은 발표 내용 외 질문이 들어올 경우에도, 알고 있는 정보를 바탕으로 최대한 답변을 시도합니다.
`;
